import '@chillibean/component-library/index.css';

import PropTypes from 'prop-types';
import { useRef, useEffect, useMemo, useState } from 'react';
import ReactNotification from 'react-notifications-component';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import AppContext from '../../context/AppContext';
import Reporting from './container/Reporting';
import { setInternal } from './redux/internal.slice';
import setupStore from './redux/store';

function FormReporting(props) {
  const { accountId, userId, accountTimezone, authenticityToken, planOptions } = props;

  const { form_template_enabled: formTemplateEnabled, sites_enabled: sitesEnabled } = planOptions;
  const notificationDomRef = useRef(null);

  const [store] = useState(setupStore());

  useEffect(() => {
    const internalValues = {
      authenticityToken,
      accountId,
      accountTimezone,
      userId,
      formTemplateEnabled,
      sitesEnabled,
    };

    store.dispatch(setInternal(internalValues));
  }, []);

  const appContextProviderValue = useMemo(() => ({ notificationDomRef }), [notificationDomRef]);

  return (
    <Provider store={store}>
      <Router basename="reporting">
        <ReactNotification ref={notificationDomRef} />
        <AppContext.Provider value={appContextProviderValue}>
          {/* <ErrorBoundary> */}
          <Reporting formTemplateEnabled={formTemplateEnabled} sitesEnabled={sitesEnabled} />
          {/* </ErrorBoundary> */}
        </AppContext.Provider>
      </Router>
    </Provider>
  );
}

FormReporting.propTypes = {
  authenticityToken: PropTypes.string.isRequired,
  accountId: PropTypes.number.isRequired,
  accountTimezone: PropTypes.string.isRequired,
  userId: PropTypes.number.isRequired,
  planOptions: PropTypes.shape({
    form_template_enabled: PropTypes.bool.isRequired,
    sites_enabled: PropTypes.bool.isRequired,
  }).isRequired,
};

export default FormReporting;
